import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  OnInit,
  DOCUMENT,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DialogService } from '../../services/dialog.service';
import { NotifierService } from '../../services/Notifierservice';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { map, switchMap } from 'rxjs';
import { RfpService } from '../../views/layout/rfpcontract/service/rfpservice.service';
import DOMPurify from 'dompurify';
@Component({
  standalone: false,
  selector: 'bot-question-answer',
  templateUrl: './bot-question-answer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bot-question-answer.component.scss',
})
export class BotQuestionAnswerComponent implements OnInit {
  @Input() data: any;
  @Input() clientId: any;
  @Input() section!: string;
  @Output() toolsAction: EventEmitter<any> = new EventEmitter();
  commentForm: FormGroup = new FormGroup({});
  synth = window.speechSynthesis;
  volumeicons: any = ['pi pi-volume-off', 'pi pi-volume-up'];
  showfeedbackForm: boolean = false;
  accurate: any;
  submitted: boolean = false;
  showTextView: boolean = false;
  isRefreshing: boolean = false;
  isSaving: boolean = false;
  isEditing: boolean = false;
  editedAnswer: string = '';
  private readonly notifier: NotifierService;
  private readonly serviceMap: Record<string, any> = {
    rfp: this.rfpService,
  };
  constructor(
    private readonly notifierService: NotifierService,
    private readonly cdr: ChangeDetectorRef,
    private readonly fb: FormBuilder,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly dialogService: DialogService,
    private readonly sanitizer: DomSanitizer,
    private readonly rfpService: RfpService,
  ) {
    this.notifier = notifierService;
  }
  ngOnInit() {
    this.commentForm = this.fb.group({
      comment: new FormControl('', [Validators.required]),
    });
    if (this.data['source_paragraphs']) {
      if (this.data['source_paragraphs'].length > 0) {
        this.data['source_document'] = this.getSourcedoc_names(
          this.data['source_paragraphs'],
        );
        this.cdr.detectChanges();
      } else {
        this.data['source_document'] = '';
      }
    }
  }

  fileSources(source_doc: any) {
    let source_docment: any = '';
    if (source_doc.length > 0) {
      source_doc.forEach((element: any) => {
        source_docment = source_docment + ' ' + element['document_name'] + ',';
      });
    }
    return source_docment.substring(0, source_docment.length - 1);
  }

  getSourcedoc_names(document_list: any) {
    let files_name: any = [];
    if (document_list.length > 0) {
      document_list.forEach((doc_key: any) => {
        if (doc_key['document_name']) {
          if (files_name.indexOf(doc_key['document_name']) == -1) {
            files_name.push(doc_key['document_name']);
          }
        }
      });

      return files_name.join(', ');
    }
  }

  onKeypressEvent(event: any) {
    // need to implement
  }

  pinRecord() {
    if (!this.data?.is_pinned) {
      this.dialogService.openConfirmDialog('', {
        title: 'Confirmation',
        message: 'Are you sure you want to pin this record?',
        btnOkText: 'Yes',
        btnCancelText: 'No',
        onClose: (data: any) => {
          if (data) {
            let data = {
              action: 'pin',
              qid: this.data?.qid,
            };
            this.toolsAction.emit(data);
          }
        },
      });
    }
  }

  actionItems(data: any) {
    this.dialogService.openConfirmDialog('', {
      title: 'Confirmation',
      message: 'Are you sure you want to generate audio?',
      btnOkText: 'Yes',
      btnCancelText: 'No',
      onClose: (data: any) => {
        if (data) {
          let data = {
            action: 'audio',
            qid: this.data?.qid,
          };
          this.toolsAction.emit(data);
        }
      },
    });
  }

  fileGenerate() {
    let data = {
      action: 'file',
      qid: this.data?.qid,
    };
    this.toolsAction.emit(data);
  }
  speakText(state: boolean, textdata: any) {
    if (!('speechSynthesis' in window)) {
      console.log('Speech synthesis not supported in this browser.');
      return;
    }
    // Make sure synth is initialized
    if (!this.synth) {
      this.synth = window.speechSynthesis;
    }
    let voices = this.synth.getVoices();
    // Log available voices once (optional, for debugging)
    if (voices.length === 0) {
      console.warn('No voices found. Voices may load asynchronously.');
    }
    let speakLanguage: string;
    let defaultVoice: string;
    speakLanguage = 'Google US English';
    defaultVoice = 'Microsoft Zira - English (United States)';
    let botVoice = voices.findIndex((v) => v.name === speakLanguage);
    let botDefaultVoice = voices.findIndex((v) => v.name === defaultVoice);
    // Clean text (remove HTML tags & &nbsp;)
    let text_question = textdata['question']
      .replace(/(<([^>]+)>)/gi, '')
      .replace(/&nbsp;/g, ' ')
      .replaceAll(/\*/g, '')
      .replaceAll(/#/g, '');
    let text_answer = textdata['answer']
      .replace(/(<([^>]+)>)/gi, '')
      .replace(/&nbsp;/g, ' ')
      .replaceAll(/\*/g, '')
      .replaceAll(/#/g, '');
    // Create utterance
    let text = text_question + ' ' + text_answer;
    const utterThis = new SpeechSynthesisUtterance(text);
    utterThis.rate = 0.9; // Slightly faster than 0.5 for better pacing
    // Select voice
    let selectedVoice;

    if (botVoice > -1) {
      selectedVoice = voices[botVoice];
    } else if (botDefaultVoice > -1) {
      selectedVoice = voices[botDefaultVoice];
    } else {
      selectedVoice = voices[0]; // fallback to first available voice
    }

    utterThis.voice = selectedVoice;
    utterThis.lang = 'en-US';
    if (state) {
      this.synth.cancel(); // stop any previous speech
      this.synth.speak(utterThis);
    } else {
      this.synth.cancel();
    }
    // Clean up toggle icon after speech ends
    const interval = setInterval(() => {
      if (!this.synth.speaking) {
        clearInterval(interval);
        document
          .querySelectorAll('.toggle-icon.is-active')
          .forEach((el) => el.classList.remove('is-active'));
      }
    }, 500);
  }

  isaccurate(data: any) {
    this.accurate = data;
    this.showfeedbackForm = true;
  }

  cancel() {
    this.showfeedbackForm = false;
    this.submitted = false;
    this.commentForm.reset();
  }

  postComment() {
    this.submitted = true;
    this.commentForm.markAllAsTouched();
    this.commentForm.markAsDirty();
    if (this.commentForm.valid) {
      let data = {
        action: 'comment',
        qid: this.data?.qid,
        accurate: this.accurate,
        comment: this.commentForm.value['comment'],
      };
      this.toolsAction.emit(data);
      this.submitted = false;
      this.showfeedbackForm = false;
      this.commentForm.reset();
    }
  }

  fileSources_para_text(source_paragraphs: any) {
    let text: any = '';
    let duplicate_check: any = [];
    if (source_paragraphs.length > 0) {
      source_paragraphs.forEach((element: any) => {
        if (duplicate_check.indexOf(element['text']) == -1) {
          text =
            text +
            ' ' +
            element['text'] +
            "<span style='color: #1d72b2;'>( Source: " +
            element['document_name'] +
            ')</span>' +
            ',';
          duplicate_check.push(element['text']);
        }
      });
    } else {
      text = source_paragraphs;
    }
    return this.safedata(text.substring(0, text.length - 1));
  }

  safedata(data: string): SafeHtml {
    return DOMPurify.sanitize(data);
  }

  toggleTextView() {
    this.showTextView = !this.showTextView;
  }

  refreshAnswer() {
    const service = this.serviceMap[this.section];
    const payload = {
      document_id: [
        ...new Set(
          (this.data.source_paragraphs ?? [])
            .map((item: any) => item.document_id)
            .filter(Boolean),
        ),
      ].join(','),
      question: [this.data.question],
      mode: 'answer',
      client_id: this.clientId,
      category_id: this.data.category_id,
      query_type: 'private',
      qid: this.data.qid,
      is_global: true,
    };
    this.isRefreshing = true;
    service.refreshAnswer(payload).subscribe({
      next: (response: any) => {
        const updated = response?.[0];
        this.data.answer = updated?.answer_plain;
        if (Array.isArray(updated?.source_paragraphs)) {
          this.data.source_paragraphs = updated.source_paragraphs;

          this.data.source_document =
            this.data.source_paragraphs.length > 0
              ? this.getSourcedoc_names(this.data.source_paragraphs)
              : '';

          this.showTextView = false;
        }
        this.data.updated_at = updated?.updated_at ?? this.data.updated_at;
        this.data.updated_by_name =
          updated?.updated_by_name ?? this.data.updated_by_name;
        this.isRefreshing = false;
        this.notifier.notify('default', 'Answer refreshed successfully.');
        this.cdr.detectChanges();
      },
      error: () => {
        this.isRefreshing = false;
      },
    });
  }

  editAnswer() {
    this.isEditing = true;
    // Strip HTML tags, decode entities, keep plain text only
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = this.data?.answer || '';
    this.editedAnswer = (tempDiv.innerText || tempDiv.textContent) ?? '';
  }

  cancelEdit() {
    this.isEditing = false;
    this.editedAnswer = '';
  }

  saveAnswer() {
    const service = this.serviceMap[this.section];
    const missedQaPayload = {
      client_id: this.clientId,
      question: this.data?.question,
      answer: this.editedAnswer,
    };
    const globalAnswerUpdatePayload = {
      client_id: this.clientId,
      qid: this.data?.qid,
      answer: `<p>${this.editedAnswer}</p>`,
      answer_plain: this.editedAnswer,
    };

    this.isSaving = true;

    service
      .updateAnswerGlobal(globalAnswerUpdatePayload)
      .pipe(
        switchMap((updateResponse: any) =>
          service.addMissedQa(missedQaPayload).pipe(map(() => updateResponse)),
        ),
      )
      .subscribe({
        next: (updateResponse: any) => {
          const updated = Array.isArray(updateResponse)
            ? updateResponse[0]
            : updateResponse;
          this.data.answer = this.editedAnswer;
          this.data.updated_at = updated?.updated_at ?? this.data.updated_at;
          this.data.updated_by_name =
            updated?.updated_by_name ?? this.data.updated_by_name;
          this.isEditing = false;
          this.editedAnswer = '';
          this.notifier.notify('success', 'Answer saved successfully.');
          this.cdr.detectChanges();
          this.isSaving = false;
        },
        error: () => {
          this.isSaving = false;
        },
      });
  }

  isNoAnswerAvailable(): boolean {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = this.data?.answer || '';

    const plainText = ((tempDiv.innerText || tempDiv.textContent) ?? '')
      .trim()
      .toUpperCase();

    return (
      plainText === 'NO ANSWER AVAILABLE' ||
      plainText === '[NO ANSWER AVAILABLE]' ||
      plainText === 'NO ANSWER'
    );
  }
}
